import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
import { QTY_SCALE } from '../../utils/quantity-scale.js';
// WHY: one good unit divides Completed from Cancelled, and the caller has already recorded consumption — see design spec §3.
export function workOrderCloseOutStatus(goodUnits) {
    if (!Number.isFinite(goodUnits) || goodUnits < 0) {
        throw new RangeError('Good-unit count must be a non-negative finite number.');
    }
    const rounded = Math.round(goodUnits * QTY_SCALE) / QTY_SCALE;
    return rounded > 0
        ? ManufacturingLifecycleStatus.COMPLETED
        : ManufacturingLifecycleStatus.CANCELLED;
}
//# sourceMappingURL=work-order-close-out-status.js.map